@if (sceneConfig()) {
  <div class="page">
    <div class="container">
      <figure fd-illustrated-message [svgConfig]="sceneConfig()">
        <figcaption fd-illustrated-message-figcaption>
          <h3
            fd-illustrated-message-title
            [innerHTML]="config().illustratedMessageTitle"
          ></h3>
          <p
            fd-illustrated-message-text
            [innerHTML]="config().illustratedMessageText"
          ></p>
        </figcaption>
        <fd-illustrated-message-actions>
          @for (button of config().buttons; track button.label) {
            <button
              fd-button
              [fdCompact]="true"
              [label]="button.label"
              (click)="goTo(button)"
            ></button>
          }
        </fd-illustrated-message-actions>
      </figure>
    </div>
  </div>
}
